export default __webpack_public_path__ + "static/media/5C.809e552d.svg";